import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;

  ul > li:last-child {
    margin-bottom: 10px;
  }
`

export const TocList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`

export const TocListItem = styled.li`
  margin-bottom: 1px;

  ${props => `
    margin-left: ${(Math.max(props.depth - 2, 0)) * 15}px;
  `}

  ${props => props.depth === 1 && `
    margin-top: 2.175rem;
    margin-bottom: 10px;
  `}
`

export const TocLink = styled.a`
  ${props => props.depth > 2 && `
    font-size: 0.9rem;
  `}

  ${props => props.depth === 1 && `
    font-size: 1rem;
    color: #aaa !important;
    text-decoration: none !important;
    word-spacing: 0rem;
    font-family: 'PT Sans', Arial, sans-serif;
    font-weight: 400;
    letter-spacing: 0.04rem;
  `}
`
